import timePeriodsApi from "../../api/timePeriods";

const state = {
  timePeriods: []
};

const getters = {};

const actions = {
  getTimePeriods(context) {
    return new Promise((resolve, reject) => {
      timePeriodsApi
        .getTimePeriods()
        .then(function(response) {
          context.commit("updateTimePeriods", response.data);
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
};

const mutations = {
  updateTimePeriods(state, value) {
    state.timePeriods = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
